/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/qaTemplateSelection.ts
 * FILE_ID: QA-TEMPLATES-SELECTION-001
 * PURPOSE: Ticking a checklist picks its steps, and the last step unticks the checklist.
 */

export interface TemplatePickState {
  selectedSectionIds: Set<string>
  selectedItemIds: Record<string, Set<string>>
}

export function toggleSectionPick(
  state: TemplatePickState,
  section: { id: string; items: readonly { id: string }[] },
): TemplatePickState {
  const selectedSectionIds = new Set(state.selectedSectionIds)
  const selectedItemIds = { ...state.selectedItemIds }
  if (selectedSectionIds.has(section.id)) {
    selectedSectionIds.delete(section.id)
    delete selectedItemIds[section.id]
    return { selectedSectionIds, selectedItemIds }
  }
  selectedSectionIds.add(section.id)
  selectedItemIds[section.id] = new Set(section.items.map((item) => item.id))
  return { selectedSectionIds, selectedItemIds }
}

export function toggleItemPick(
  state: TemplatePickState,
  sectionId: string,
  itemId: string,
): TemplatePickState {
  const selectedItemIds = { ...state.selectedItemIds }
  const items = new Set(selectedItemIds[sectionId] ?? [])
  if (items.has(itemId)) items.delete(itemId)
  else items.add(itemId)
  selectedItemIds[sectionId] = items
  const selectedSectionIds = new Set(state.selectedSectionIds)
  if (items.size > 0) selectedSectionIds.add(sectionId)
  else selectedSectionIds.delete(sectionId)
  return { selectedSectionIds, selectedItemIds }
}
